import { hasUnresolvedAssistant } from './hasUnresolvedAssistant'

export function scheduleUnresolvedFetchRetry(id, setMessagesByThreadId) {
  return window.setTimeout(() => {
    setMessagesByThreadId((prev) => {
      const current = prev[id] ?? []
      if (!hasUnresolvedAssistant(current)) return prev
      return { ...prev, [id]: current.slice() }
    })
  }, 2500)
}
